import { Controller } from "@hotwired/stimulus"

// Renders a photo_v1 block's uploaded file asset - used both by the Story
// viewer's photo_v1 blocks and the homer_block_viewers/_photo_v1_block_viewer
// partial (fundraising event status updates, campaign contributions).
export default class extends Controller {
  static get values() {
    return { apiReference: String }
  }

  connect() {
    this.fetchFileAsset()
  }

  async fetchFileAsset() {
    try {
      const response = await fetch(`/api/v1/file-assets/${this.apiReferenceValue}`, {
        headers: { Accept: "application/json" }
      })
      if (!response.ok) throw new Error("Failed to load file asset")

      const data = await response.json()
      this.render(data.data)
    } catch (error) {
      console.error(error)
    }
  }

  render(fileAsset) {
    const imgUrl = fileAsset.attributes.is_processing
      ? `https://cdn.filestackcontent.com/resize=width:700/${fileAsset.attributes.filestack_meta_info.handle}`
      : fileAsset.attributes.url

    this.element.innerHTML = `<img src="${this.escapeHtml(imgUrl)}">`
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }
}
